import React from "react";
import { translate } from "@/i18n/translations";

/**
 * Session-only language switcher. Defaults to "en" every time the app
 * loads (business rule Feb 2026: user explicitly opted OUT of persistence).
 * The toggle in the top-right header flips between "en" and "zh".
 */
const LanguageContext = React.createContext({
  lang: "en",
  setLang: () => {},
  t: (s) => s,
});

export function LanguageProvider({ children }) {
  const [lang, setLang] = React.useState("en");
  // Memoize the `t` fn so consumers can safely depend on it in effects
  // without triggering re-runs on every render.
  const t = React.useCallback((text) => translate(text, lang), [lang]);
  const value = React.useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

/**
 * useT — returns `{ t, lang, setLang }`. Prefer this hook over reading
 * the context directly so refactors stay contained.
 */
export function useT() {
  return React.useContext(LanguageContext);
}
